import { Notification as notify } from 'element-ui';
import i18n from "../../utils/i18n";


export default function Validator(type, data) {
  var title,writePhone,errWritePhone,writeEmail;
  if (i18n.locale === 'en') {
    title = 'Error';
    writePhone = 'Please fill in your mobile phone number';
    errWritePhone = 'The mobile phone number is wrong, please fill in again';
    writeEmail = 'Please fill in the correct email address';
  }else{
    title = '錯誤';
    writePhone = '請填寫手機號';
    errWritePhone = '手機號碼有誤，請重填';
    writeEmail='請填寫正確的郵箱地址';
  }

  switch (type) {
    default:
      return false;
    case 'mobile':
      console.log(data)
      if (!data.mobile) {
        notify.error({
          title:title, message: writePhone});
        $('.mobile').focus();
        return false;
      }
      if((data.areaCode === '86') && !(/^1[3456789]\d{9}$/.test(data.mobile))){
        notify.error({title: title, message: errWritePhone});
        $('.mobile').focus();
        return false;
      }
      if((data.areaCode === '852') && !(/^(5|6|8|9)\d{7}$/.test(data.mobile))){
        notify.error({title: title, message: errWritePhone});
        $('.mobile').focus();
        return false;
      }
      return true;
    case 'email':
      let emailReg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!data.email || !emailReg.test(data.email)) {
        notify.error({
          title: title,
          message: writeEmail
        });
        $('.email').focus();
        return false;
      } else {
        return true;
      }
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/Validator.js